import axios from "axios";
import { X, Clock, CheckCircle, XCircle, Wallet, SwatchBook } from "lucide-react";
import { useState } from "react";
import { showError, showSuccess } from "../../../utils/toastUtils";

const paymentStatusOptions = [
  {
    value: "pending_verification",
    label: "Pending Verification",
    icon: Clock,
    color: "text-yellow-600",
  },
  {
    value: "paid",
    label: "Paid(Via WhatsApp)",
    icon: CheckCircle,
    color: "text-emerald-600",
  },
  {
    value: "partially_paid",
    label: "Partially Paid(Via WhatsApp)",
    icon: SwatchBook,
    color: "text-blue-600",
  },
  {
    value: "payment_pending",
    label: "Payment Pending",
    description: "Payment will be collected after service",
    icon: Wallet,
    color: "text-blue-600",
    highlight: true,
  },
];

// bookingType: "service" | "package"
const PaymentStatusUpdateModal = ({
  isOpen,
  onClose,
  booking,
  onSuccess,
  bookingType = "service",
}) => {
  const finalAmount = booking?.finalPayableAmount || 0;
  const alreadyPaid = booking?.payment?.paidAmount || 0;
  const remaining = finalAmount - alreadyPaid;

  const [selectedStatus, setSelectedStatus] = useState(
    booking?.payment?.status || "pending_verification",
  );
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);

  if (!isOpen || !booking) return null;

  const requiresAmount = selectedStatus === "partially_paid";

  // ── Pick the right endpoint based on bookingType ──
  const getEndpoint = () => {
    if (bookingType === "package") {
      return `${process.env.REACT_APP_API_URL}/package-bookings/${booking._id}/payment`;
    }
    return `${process.env.REACT_APP_API_URL}/service-bookings/update-payment-status/${booking._id}`;
  };

  const handleUpdate = async () => {
    try {
      setLoading(true);

      const payload = { status: selectedStatus };

      if (requiresAmount) {
        if (!amount || Number(amount) <= 0) {
          showError("Enter valid amount");
          return;
        }
        payload.amount = Number(amount);
      }

      await axios.patch(getEndpoint(), payload);

      showSuccess("Payment status updated");
      onSuccess?.();
      onClose();
    } catch (err) {
      showError(
        err?.response?.data?.message || "Failed to update payment status",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/50 z-50 overflow-y-auto"
      onClick={onClose}
    >
      <div className="flex min-h-full items-center justify-center p-4">
        <div
          className="bg-white rounded-xl shadow-2xl w-full max-w-md max-h-[90vh] flex flex-col"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div className="flex items-center justify-between p-5 border-b bg-[#EDB5A4]">
            <h3 className="text-lg font-semibold">Update Payment Status</h3>
            <button onClick={onClose}>
              <X size={22} />
            </button>
          </div>

          {/* Payment Info */}
          {selectedStatus === "partially_paid" && (
            <div className="p-5 border-b bg-gray-50 text-sm space-y-1">
              <div>Final Amount: ₹{finalAmount}</div>
              <div>Already Paid: ₹{alreadyPaid}</div>
              <div className="font-semibold">Remaining: ₹{remaining}</div>
            </div>
          )}

          {/* Status Options */}
          <div className="p-6 space-y-4 overflow-y-auto">
            {paymentStatusOptions.map((option) => {
              const Icon = option.icon;
              const isSelected = selectedStatus === option.value;
              const isPartial = option.value === "partially_paid";

              return (
                <div
                  key={option.value}
                  className={`w-full flex items-center justify-between gap-4 p-4 rounded-xl border transition cursor-pointer
                    ${isSelected
                      ? "border-accentTextColor bg-[#EDB5A4]/10"
                      : "border-gray-200 hover:bg-gray-50"
                    }`}
                  onClick={() => setSelectedStatus(option.value)}
                >
                  <div className="flex items-center gap-3">
                    <Icon size={20} className={option.color} />
                    <span className="font-medium">{option.label}</span>
                  </div>

                  <div className="flex items-center gap-3">
                    {isPartial && isSelected && (
                      <input
                        type="number"
                        value={amount}
                        onClick={(e) => e.stopPropagation()}
                        onChange={(e) => setAmount(e.target.value)}
                        placeholder="Amount"
                        className="w-28 px-3 py-1.5 text-sm border rounded-lg focus:outline-none focus:ring-1 focus:ring-accentTextColor no-spinner"
                      />
                    )}
                    {isSelected && (
                      <CheckCircle size={18} className="text-accentTextColor" />
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Footer */}
          <div className="flex gap-3 p-5 border-t bg-gray-50">
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2 border rounded-lg"
            >
              Cancel
            </button>
            <button
              onClick={handleUpdate}
              disabled={loading}
              className="flex-1 px-4 py-2 bg-accentTextColor text-white rounded-lg disabled:opacity-50"
            >
              {loading ? "Updating..." : "Update"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentStatusUpdateModal;












// import axios from "axios";
// import { X, Clock, CheckCircle, XCircle, Wallet, SwatchBook } from "lucide-react";
// import { useState } from "react";
// import { showError, showSuccess } from "../../../utils/toastUtils";

// const paymentStatusOptions = [
//   {
//     value: "pending_verification",
//     label: "Pending Verification",
//     icon: Clock,
//     color: "text-yellow-600",
//   },
//   {
//     value: "paid",
//     label: "Paid(Via WhatsApp)",
//     icon: CheckCircle,
//     color: "text-emerald-600",
//   },
//   {
//     value: "partially_paid",
//     label: "Partially Paid(Via WhatsApp)",
//     icon: SwatchBook,
//     color: "text-blue-600",
//   },
//   {
//     value: "payment_pending",
//     label: "Payment Pending",
//     description: "Payment will be collected after service",
//     icon: Wallet,
//     color: "text-blue-600",
//     highlight: true,
//   },
//   // {
//   //   value: "refunded",
//   //   label: "Refunded",
//   //   icon: XCircle,
//   //   color: "text-red-600",
//   // },
// ];

// const PaymentStatusUpdateModal = ({
//   isOpen,
//   onClose,
//   booking,
//   onSuccess,
// }) => {
//   const finalAmount = booking?.finalPayableAmount || 0;
//   const alreadyPaid = booking?.payment?.paidAmount || 0;
//   const remaining = finalAmount - alreadyPaid;

//   const [selectedStatus, setSelectedStatus] = useState(
//     booking?.payment?.status || "pending_verification",
//   );

//   const [amount, setAmount] = useState("");
//   const [loading, setLoading] = useState(false);

//   if (!isOpen || !booking) return null;

//   const requiresAmount =
//     selectedStatus === "partially_paid"
//     // ||
//     // (selectedStatus === "paid" && remaining > 0);

//   const handleUpdate = async () => {
//     try {
//       setLoading(true);

//       const payload = { status: selectedStatus };

//       if (requiresAmount) {
//         if (!amount || Number(amount) <= 0) {
//           showError("Enter valid amount");
//           return;
//         }

//         payload.amount = Number(amount);
//       }

//       await axios.patch(
//         `${process.env.REACT_APP_API_URL}/service-bookings/update-payment-status/${booking._id}`,
//         payload,
//       );

//       showSuccess("Payment status updated");
//       onSuccess?.();
//       onClose();
//     } catch (err) {
//       showError(
//         err?.response?.data?.message || "Failed to update payment status",
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div
//       className="fixed inset-0 bg-black/50 z-50 overflow-y-auto"
//       onClick={onClose}
//     >
//       <div className="flex min-h-full items-center justify-center p-4">
//         <div
//           className="bg-white rounded-xl shadow-2xl w-full max-w-md max-h-[90vh] flex flex-col"
//           onClick={(e) => e.stopPropagation()}
//         >
//           {/* Header */}
//           <div className="flex items-center justify-between p-5 border-b bg-[#EDB5A4]">
//             <h3 className="text-lg font-semibold">
//               Update Payment Status
//             </h3>
//             <button onClick={onClose}>
//               <X size={22} />
//             </button>
//           </div>

//           {/* Payment Info */}
//           {selectedStatus === "partially_paid" && (
//             <div className="p-5 border-b bg-gray-50 text-sm space-y-1">
//               <div>Final Amount: ₹{finalAmount}</div>
//               <div>Already Paid: ₹{alreadyPaid}</div>
//               <div className="font-semibold">
//                 Remaining: ₹{remaining}
//               </div>
//             </div>
//           )}

//           {/* Status Options */}
//           <div className="p-6 space-y-4 overflow-y-auto">
//             {paymentStatusOptions.map((option) => {
//               const Icon = option.icon;
//               const isSelected = selectedStatus === option.value;
//               const isPartial = option.value === "partially_paid";

//               return (
//                 <div
//                   key={option.value}
//                   className={`w-full flex items-center justify-between gap-4 p-4 rounded-xl border transition
//           ${isSelected
//                       ? "border-accentTextColor bg-[#EDB5A4]/10"
//                       : "border-gray-200 hover:bg-gray-50"
//                     }`}
//                   onClick={() => setSelectedStatus(option.value)}
//                 >
//                   {/* LEFT SIDE */}
//                   <div className="flex items-center gap-3">
//                     <Icon size={20} className={option.color} />
//                     <span className="font-medium">{option.label}</span>
//                   </div>

//                   {/* RIGHT SIDE */}
//                   <div className="flex items-center gap-3">
//                     {/* Amount Input ONLY for Partial + Selected */}
//                     {isPartial && isSelected && (
//                       <input
//                         type="number"
//                         value={amount}
//                         onClick={(e) => e.stopPropagation()}
//                         onChange={(e) => setAmount(e.target.value)}
//                         placeholder="Amount"
//                         className="w-28 px-3 py-1.5 text-sm border rounded-lg focus:outline-none focus:ring-1 focus:ring-accentTextColor no-spinner"
//                       />
//                     )}

//                     {isSelected && (
//                       <CheckCircle size={18} className="text-accentTextColor" />
//                     )}
//                   </div>
//                 </div>
//               );
//             })}
//           </div>

//           {/* Footer */}
//           <div className="flex gap-3 p-5 border-t bg-gray-50">
//             <button
//               onClick={onClose}
//               className="flex-1 px-4 py-2 border rounded-lg"
//             >
//               Cancel
//             </button>
//             <button
//               onClick={handleUpdate}
//               disabled={loading}
//               className="flex-1 px-4 py-2 bg-accentTextColor text-white rounded-lg disabled:opacity-50"
//             >
//               Update
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PaymentStatusUpdateModal;
